import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { AI_BASIC_Schema } from './AI_BASIC_Schema';
import { useSelector } from 'react-redux';

// 보이스 체크 내용 조회
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(AI_BASIC_Schema.mapper.search1);
  const searchInfo = useSelector((state) => state.SearchInfo);

  const query = useQuery({
    queryKey: ['Aicall', 'getAiBasic01R1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.Aicall.getAiBasic01R1, params),
    enabled: !!searchInfo?.custCd,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
// 보이스 체크 현황 조회
export const useSearch2 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(AI_BASIC_Schema.mapper.search2);

  const query = useQuery({
    queryKey: ['Aicall', 'getAiBasic02R1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.Aicall.getAiBasic02R1, params),

    enabled: true, // 자동 실행 여부
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
// 보이스 체크 내용 저장
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, AI_BASIC_Schema.mapper.save1);
    return apiRequest('post1', Global.urls.Aicall.saveAiBasicU1, payload);
  }, options);
};
// 보이스 체크 순번 재설정 요청 정보 배열
export const useSave2 = (context = {}, options = {}) => {
  return useSaveMutation(async () => {
    const payload = mapParamsBySchema(AI_BASIC_Schema.mapper.save2, context);
    return apiRequest('post1', Global.urls.Aicall.saveAiBasicU3, [payload]);
  }, options);
};
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, AI_BASIC_Schema.mapper.delete1);
    return apiRequest('post1', Global.urls.Aicall.deleteAiBasicD1, payload);
  }, options);
};
